import type { WebPushSubscribeBody, WebPushUnsubscribeBody } from 'src/openapi';
import { formatToFetchError } from 'src/helpers/utils';
import apiClient from 'src/helpers/apiClient';
import appApi from './index';

export const webPushApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    saveWebPushSubscription: build.mutation<void, WebPushSubscribeBody>({
      queryFn: async (body) => {
        try {
          await (
            await apiClient.getNotificationsApi()
          ).notificationApiSaveWebPushSubscription({
            webPushSubscribeBody: body,
          });
          return { data: undefined };
        } catch (err: any) {
          return formatToFetchError(err);
        }
      },
    }),
    removeWebPushSubscription: build.mutation<void, WebPushUnsubscribeBody>({
      queryFn: async (body) => {
        try {
          await (
            await apiClient.getNotificationsApi()
          ).notificationApiDeleteWebPushSubscription({
            webPushUnsubscribeBody: body,
          });
          return { data: undefined };
        } catch (err: any) {
          return formatToFetchError(err);
        }
      },
    }),
    dismissWebPushPrompt: build.mutation<void, void>({
      queryFn: async () => {
        try {
          await (
            await apiClient.getNotificationsApi()
          ).notificationApiDismissWebPushPrompt();
          return { data: undefined };
        } catch (err: any) {
          return formatToFetchError(err);
        }
      },
    }),
  }),
});

export const {
  useSaveWebPushSubscriptionMutation,
  useRemoveWebPushSubscriptionMutation,
  useDismissWebPushPromptMutation,
} = webPushApi;
